//@flow
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './App';
import './App.scss';
import 'bootstrap';
import * as serviceWorker from './serviceWorker';
// import 'react-select/dist/react-select.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'cropperjs/dist/cropper.css';
import 'react-month-picker/css/month-picker.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { defineAbilitiesFor } from './helpers/ability.helper';
import { AbilityContext, ability } from './context/AbilityContext';
import { getCurrentUser } from './helpers/permissions.helper';

const user = getCurrentUser();
const userAbility = defineAbilitiesFor(user);
ability.update(userAbility.rules);

const root = document.getElementById('root');

if (root !== null) {
  ReactDOM.render(
    <Provider store={store}>
      <AbilityContext.Provider value={ability}>
        <App />
      </AbilityContext.Provider>
    </Provider>,
    root
  );
}
serviceWorker.unregister();
